import React, { DetailedHTMLProps, PropsWithChildren, useMemo } from "react"

const Label = React.forwardRef<HTMLLabelElement, Props>( ( { className: _className, ...props }, ref ) => {

    const className = useMemo( () => {
        return [
            'flex flex-col items-start my-1',
            ...( _className?.split( ' ' ) ?? [] )
        ].join( ' ' )
    }, [ _className ] )

    return (
        <label
            className={ className }
            { ...props }
        />
    )
})

interface Props extends PropsWithChildren<DetailedHTMLProps<any, HTMLLabelElement>> {

}

export { Label }
